<script>
	import Chip, { Set } from "@smui/chips";
	export let value = -1;
	export let chips = ['Yes', 'No'];
	export let option = false;
</script>

<style>
	.question {
		color: black
	}
</style>

<div class={option ? "question mb-1 ml-4" : "question mb-3"}>
	<slot>Select an option</slot>
	<Set class="ml-2" {chips} let:chip choice bind:selected={value}>
		<Chip ripple={false} tabindex="0">{chip}</Chip>
	</Set>
	<slot name="footer" />
</div>
